import React from 'react'

const Organigramme = () => {
  return (
    <div className="pt-24 pb-16 min-h-screen bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-5xl font-bold text-cidh-blue mb-4 font-montserrat">Organigramme du Cabinet CIDH Consulting SARL</h1>
          <div className="w-20 h-1.5 bg-cidh-gold mx-auto mb-8"></div>
        </div>
        
        <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 p-4 md:p-8">
          <img 
            src="/images/organigramme.jpeg" 
            alt="Organigramme CIDH Consulting" 
            className="w-full h-auto object-contain rounded-lg"
          />
        </div>

        <div className="mt-12 text-center text-gray-500 italic">
          <p>Structure organisationnelle mise à jour le 28 Mars 2026</p>
        </div>
      </div>
    </div>
  )
}

export default Organigramme
